module.exports = __webpack_public_path__ + "img/4.e092a579.jpg";